import { Skeleton } from "@chakra-ui/react";

import { useMetabaseDashboard } from "../../hooks/useMetabaseDashboard";

export default function DepositData() {
  const { iframeUrl, loading, onLoad } = useMetabaseDashboard(64);

  return (
    <>
      {loading ? (
        <Skeleton
          height="100vh"
          width="100%"
          marginTop={4}
          startColor="gray.100"
          endColor="gray.200"
        />
      ) : null}
      <iframe
        src={iframeUrl}
        onLoad={onLoad}
        title="deposits"
        style={{ width: "100%", height: "100vh", border: "none" }}
      />
    </>
  );
}
